// 特殊な動作を行う点検を判断するための情報

export const INSPECT_VALUE_VIEW_TYPE = {
  BATTERY:     1, // バッテリー
  TIRE:        2, // タイヤ
  SIDE_SLIP:   3, // サイドスリップ
  BRAKE:       4, // 前ブレーキ
  SPEED:       5, // スピードメーター
  BRAKE_REAR:  6, // 後ブレーキ
  SUNFLARE:    7, // サンフレア
  BOOTS:       8, // ブーツ系列
  BASIC_OBD:   9, // OBD検査項目
  SYNC_OBD:   10, // OBD検査項目(警告灯連動)
  GROUND_CLR: 11, // 最低地上高連動
};

// 許容範囲の設定
export const INSPECT_VALUE_LINE = {
  BATTERY: [ 12.0 , 12.5 ],
  TIRE: [ 2.5 , 4.0 ],
  SIDE_SLIP: [ 0 , 5 ], // 範囲値
  BRAKE: [ 4 , 5 ],
  SPEED: [ 31 , 42.5 ], // 範囲値
  BRAKE_REAR: [ 2 , 3 ],
};
export const INSPECT_VALUE_NEXTAGE = {
  BATTERY: [ -1 , -1 ], // チェックしない
  TIRE: [ 1.6 , 4.0 ],
  SIDE_SLIP: [ 0 , 5 ], // 範囲値
  BRAKE: [ 3 , 5 ],
  SPEED: [ 31 , 42.5 ], // 範囲値
  BRAKE_REAR: [ 3 , 5 ],
};

// 値を配列で持っている点検項目の設計情報
export const INSPECT_VALUE_LENGTH = [
  0, // 通常
  1, // BATTERY
  4, // TIRE
  1, // SIDE_SLIP
  2, // BRAKE
  1, // SPEED
  2, // BRAKE_REAR
  2, // SUNFLARE
  1, // BOOTS
  0, // OBD1
  0, // OBD2
  0, // GRAND_CLEARANCE
];

export const INSPECT_VALUE_LABEL_TYPE = {
  0: {
    label: "特殊指定なし",
    description: ""
  },
  1: {
    label: "バッテリー用特殊動作",
    description: "バッテリー用特殊動作です。点検選択時に計測結果を 1 件追加記入する挙動をします。"
  },
  2: {
    label: "タイヤ用特殊動作",
    description: "タイヤ用特殊動作です。点検選択時に左前・右前・左後・右後の残り溝を追加記入する挙動をします。"
  },
  3: {
    label: "サイドスリップ用特殊動作",
    description: "サイドスリップ用特殊動作です。点検選択時にIN/OUT と計測結果を追加記入する挙動をします。"
  },
  4: {
    label: "前ブレーキ用特殊動作",
    description: "前ブレーキ用特殊動作です。点検選択時に左残数・右残数を追加記入する挙動をします。"
  },
  5: {
    label: "スピードメーター用特殊動作",
    description: "スピードメーター用特殊動作です。実測 40km 時のメーター表示を表示します。"
  },
  6: {
    label: "後ブレーキ用特殊動作",
    description: "後ブレーキ用特殊動作です。点検選択時に左残数・右残数を追加記入する挙動をします。"
  },
  7: {
    label: "サンフレア用特殊動作",
    description: "サンフレア用特殊動作です。点検選択時に有効期限を追加記入する挙動をします。"
  },
  8: {
    label: "ブーツ系列特殊動作",
    description: "ブーツ系列の特殊動作です。点検選択時にヒビ割れ状態を追加記入する挙動をします。"
  },
  9: {
    label: "OBD系検査項目特殊動作",
    description: "OBD検査項目用の特殊動作をします。現車と57点検項目で共通の点検項目を表示します。"
  },
  10: {
    label: "OBD系検査項目特殊動作(警告灯連動あり)",
    description: "OBD検査項目用の特殊動作をします。現車と57点検項目で共通の点検項目を表示します。"
  },
  11: {
    label: "最低地上高(車両情報連動あり) ",
    description: "最低地上高用特殊動作です。点検選択時に高さ記入する挙動をする他、車両情報の最低地上高の選択を引き継ぎます"
  }
};
